import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "@ctms/api.service";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {RouterLink} from "@angular/router";
import {BreadcrumbService} from "@cdss/services/breadcrumb.service";

@Component({
    selector: 'demo-patient-add-record',
    imports: [CommonModule, ReactiveFormsModule, NgSelectModule, NgxDatatableModule],
    providers: [ApiService],
    standalone: true,
    templateUrl: './patient-add-record.component.html'
})
export class DemoPatientAddRecordComponent {

    constructor(
        private breadcrumbService: BreadcrumbService,
    ) {
    }

    ngOnInit(): void {

    }
}
